"use client";

import styled from "styled-components";
import { Input } from "../form";

export const BoxMutiple = styled.div`
  width: 100%;
`;

export const InputSearch = styled(Input)`
  margin-bottom: 5px;
`;

export const ListSelect = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 10px;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid var(--borderColor);
`;

export const ListSelectItem = styled.li`
  font-family: "Inter Regular";
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid var(--borderColor);
  color: var(--textLight);
  transition: 0.3s;

  &:hover {
    background: var(--borderColor);
    color: #fff;
  }
`;

export const BoxListSelect = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`;

export const ButtonSelect = styled.div`
  display: flex;
  align-items: center;
  background: var(--primarySystem100);
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  font-family: "Inter Normal";
  font-size: 14px;
`;

export const ButtonClose = styled.div`
  padding: 3px;
  border-radius: 50px;
  background: var(--primarySystem100);
  border: none;
  cursor: pointer;
  font-weight: 700;
  margin-left: 3px;
  height: 16px;
  width: 16px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #fff;
    color: var(--primarySystem100);
  }
`;
